module.exports = __webpack_public_path__ + "static/media/web.1e6ecb9f.png";